export default {
  warningTitle: {
    id: 'asp_action_bar_refund_step_warning_title',
    defaultMessage: "Heads up: Once you start a refund, you can't undo it.",
  },
  defaultLabel: {
    id: 'asp_action_bar_refund_step_warning_label',
    defaultMessage:
      'The maximum refundable amount for this item is {maxRefundablePrice}.',
  },
  fullRefundLabel: {
    id: 'asp_action_bar_refund_step_warning_full_refund_label',
    defaultMessage:
      'You must make a refund for the full amount ({maxRefundablePrice}) because the order hasn’t shipped yet.',
  },
  productQuantityRemark: {
    id: 'asp_action_bar_refund_step_first_remark',
    defaultMessage:
      'Please note that the amount displayed includes the price of all {productQuantity} items, shipping costs, and any potential additional costs (e.g. Quality Assurance Fee)',
  },
  insurancePolicyRemark: {
    id: 'asp_action_bar_refund_step_second_remark',
    defaultMessage:
      'Please note that a partial refund will not affect the customer’s insurance policy if they have one',
  },
}
